import {Text, Layout, EitjeButton} from '~/components'
import {goBack} from '~/routing/actions'
import {t} from '~/initializers/i18n'

export const ShowUserHeader = ({name}) => {
	return (
		<Layout width="full" margin="24 - - -" direction="horizontal">
			<EitjeButton iconLeft="arrow-left" onClick={goBack} />
			<Text bold fontSize={18}>
				{t('headers.user', {name})}
			</Text>
		</Layout>
	)
}
